
export default function registerWin($, apower) {
  //window
  $.registerComponent('win', {

    template: `
		<div class="win" f-loading="loading">
			<div class="win-head" ref="head"></div>
			<div class="win-body" ref="body"></div>
			<div class="win-foot" ref="foot"></div>
		</div>
	`,

    autoDestroy: false,

    target: 'body',

    mask: true,

    hideByDefault: true,

    scrollTop: 0,

    onReady () {
      if (this.hideByDefault) {
        this.el.hide()
      }

      if (this.body) {
        this.body.stopScroll()
      }

      this.on('show', this.onShow, this)
      this.on('hide', this.onHide, this)

      if (this.mask) {
        this.maskEl = $('<div class="win-mask" ref="maskEl"></div>')

        this.on('show', (duration) => {
          this.el.before(this.maskEl)
          this.maskEl.css('z-index', this.el.css('z-index'))
          this.maskEl.stop().fadeIn(duration)
        })

        this.on('hide', () => {
          this.maskEl.stop().fadeOut(200)
        })

        this.on('destroy', () => {
          this.maskEl.remove()
        })
      }

      this.closeEl = this.createFromTemplate('<div class="win-close" ref="closeEl"><icon type="close-wide"></icon></div>').appendTo(this.el)
      this.closeEl.on('click', this.whenCloseWin, this)
    },


    onDestroy () {
      $(window).off('resize', this.alignWin, this)
      $('body').removeClass('body-fixed')
      $(document).scrollTop(-this.scrollTop)
      if (this.maskEl) {
        this.maskEl.remove()
      }
    },

    show (duration = 200) {
      this.el.show()
      this.el.css('display', 'flex')
      this.alignWin()
      this.el.stop().fadeIn(duration)
      this.trigger('show', duration)
      this.scrollTop = -$(document).scrollTop()
      $('body').addClass('body-fixed')
      $('body').css('top',this.scrollTop + 'px')
      $(window).on('resize', this.alignWin, this)
    },


    alignWin () {
      this.el.alignTo(document.body, 'c')
    },


    onShow () {},


    onHide () {},


    hide () {
      this.el.stop().fadeOut(200, this.onHidden.bind(this))
      this.trigger('hide')
      $('body').removeClass('body-fixed')
      $(document).scrollTop(-this.scrollTop)
      if($.env.isMobile){
        $('body').removeClass('body-static')
      }
      $(window).off('resize', this.alignWin, this)
    },

    whenCloseWin(){
      this.hide()
    },


    onHidden () {
      if (this.autoDestroy) {
        this.destroy()
      }
    },


    //old API
    showLoading () {
      this.loading = true
    },

    //old API
    hideLoading () {
      this.loading = false
    },
  })
  $.getComponent('win').prototype.selector = '.win'
  $.getComponent('win').prototype.ref = {
    'head': '.win-head',
    'body': '.win-body',
    'foot': '.win-foot',
  }
  $.getComponent('win').prototype.init = function () {
    //for old API
    if (this.el.parent().is('.win-mask')) {
      var oldMaskEl = this.el.parent()
      oldMaskEl.after(this.el)
      oldMaskEl.remove()
    }
  }
}